export default __webpack_public_path__ + "static/media/gpfinder.d44d4940.png";